import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemButton from '@mui/material/ListItemButton';
import {Grid, Divider, Paper} from '@mui/material';

import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
//import logo from '../../assets/Banner/cropped-CMDFW_LOGO_14.png';
import logo from '../../assets/images/cards/CmdfwHeaderLogo.jpg';
import smalllogo from '../../assets/images/cards/Chinmaya-Mission-Logo.gif';
import { useMember } from '../../context/MemberProfileContext';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { ListItem, ListItemIcon} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';


const drawerWidth = 250;


function HeaderBar({ drawerOpen, handleDrawerToggle }) {
  const { handleLogout, isLoggedIn } = useAuth();
  console.log("Entry Header Bar form :", isLoggedIn);
  const { memberProfile, setMemberProfile, personName } = useMember();  
  const [anchorElRight, setAnchorElRight] = useState(null);
  const [anchorElLeft, setAnchorElLeft] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [broadcastMessage, setBroadcastMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // New state for error message 
  console.log("HeaderBar - memberProfile :", broadcastMessage, isLoggedIn, memberProfile, drawerOpen, handleDrawerToggle);

  useEffect(() => {
      
        fetchBroadcastMessage();
        console.log("Broadcase message :");   
      
    }, []);
  const fetchBroadcastMessage = async () => {
    const API_URL = process.env.REACT_APP_API_URL;
    let response, data;
    try {
      response = await fetch(`${API_URL}/broadcast`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        data = await response.json();
        if (data.length > 0) {
          setBroadcastMessage(data[0].message); // Set the broadcast message to state
          //console.log("Broadcast message data:", response, data, data[0].message);
        } else {
          // No active broadcast — leave both states empty so the banner stays hidden
        }
      } else {
        setErrorMessage("Site is currently under maintenance. Please try again later"); // Set error message on response error
        //console.error('Error fetching broadcast message:', response.statusText);
      }
    } catch (error) {
      setErrorMessage("Site is currently under maintenance. Please try again later"); // Set error message on response error
      //console.error('Error fetching broadcast message:', error);
    }
  };
  
  const handleRightMenuOpen = (event) => {
    setAnchorElRight(event.currentTarget);
  };

  const handleRightMenuClose = () => {
    setAnchorElRight(null);
  };

const handleNavigation = (path) => {
  navigate(path);
  handleDrawerToggle();
};
  const onLogout = () => {
    handleLogout();
    navigate('/');
};


  return (
    <>
   <AppBar
  position="static"
  elevation={0}
  sx={{
    background: 'linear-gradient(90deg, #c2e0f0 0%, #ebf5fc 40%, #ebf5fc 60%, #c2e0f0 100%)',
    borderBottom: '1px solid #b0cfe0',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: (isLoggedIn && !isMobile) ? `${drawerWidth}px` : 0,
    width: (isLoggedIn && !isMobile) ? `calc(100% - ${drawerWidth}px)` : '100%',
  }}
>
    <Toolbar sx={{ justifyContent: 'space-between' }}>

          {/* Left side - Menu button */}
          {isLoggedIn && isMobile && (
            <IconButton sx={{ color: '#333' }} onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
          )}

          {/* Centered logo */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <img
            src={logo}
            alt="CMDFW Logo"
            style={{
              maxHeight: isMobile ? '60px' : '100px',
              maxWidth: isMobile ? '220px' : 'none',
              width: 'auto',
            }}
          />
          </Box>

          {/* Right side - Logout button only if logged in */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            {isLoggedIn && (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <IconButton sx={{ color: '#333' }}>
                    <PersonIcon />
                  </IconButton>
                  <Typography variant="caption" sx={{ color: '#333' }}>{personName}</Typography>
                </Box>
                <Menu
                  anchorEl={anchorElRight}
                  open={Boolean(anchorElRight)}
                  onClose={handleRightMenuClose}
                >
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {(broadcastMessage || errorMessage) && <Grid item xs={12} sm={12}>
        <Paper style={{
              padding: '16px',
              backgroundColor: '#dfe7e7',
              color: 'black',
              transition: theme.transitions.create(['margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              width: (isLoggedIn && !isMobile) ? `calc(100% - ${drawerWidth}px)` : '100%',
              marginLeft: (isLoggedIn && !isMobile) ? `${drawerWidth}px` : 0,
            }}
      elevation={3}
    >
            <Grid item>
              <Box sx={{ width: '100%', minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto',
                
               }}>
              <Typography variant="body2" align="center" gutterBottom>
                {broadcastMessage ? (
                  <div>
                    <b>Balavihar Registration: {broadcastMessage}</b>
                    <div><br /></div>
                    <b>Read FAQ/How to Register document before you proceed:</b> <a href="https://membership.cmdfw.org/docs/FAQ_How to Register.pdf" target="_blank" rel="noopener noreferrer"> Open FAQ </a>

                  </div>
                ) : (
                  <div style={{ fontWeight: 'bold', color: 'red', fontSize: '18px' }}>
                    <b>{errorMessage}</b>
                  </div>
                )}
              </Typography>
              </Box>
            </Grid>
          </Paper>
      </Grid>}

      {/* Mission Statement */}
      <Box sx={{
        bgcolor: '#f8f4ec',
        py: 1.5,
        textAlign: 'center',
        borderBottom: '1px solid #e0d8c8',
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: (isLoggedIn && !isMobile) ? `calc(100% - ${drawerWidth}px)` : '100%',
        marginLeft: (isLoggedIn && !isMobile) ? `${drawerWidth}px` : 0,
      }}>
        <Typography variant="body1" sx={{ color: '#4a3a1f', fontFamily: 'Georgia, serif', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
          Our Mission
        </Typography>
        <Typography variant="body1" sx={{ fontStyle: 'italic', color: '#4a3a1f', fontFamily: 'Georgia, serif', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
          "To give maximum happiness to maximum people for maximum time"
        </Typography>
        <Typography variant="caption" sx={{ color: '#8a7455', display: 'block', mt: 0.25 }}>
          — Pujya Gurudev Swami Chinmayananda
        </Typography>
      </Box>

      {/* Drawer for both mobile and desktop devices */}
      {isLoggedIn && (

      <Drawer
        anchor={isMobile ? 'left' : 'left'}
        variant={isMobile ? 'temporary' : 'permanent'}
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderRadius: '8px' },
        }}
      >
        <Grid item xs={12} sm={12}>
          <img src={smalllogo} className="App-logo" alt="logo" />
        </Grid>
        <Divider sx={{ borderBottomWidth: 4 }} />

        <List>
          {memberProfile.menus && memberProfile.menus.map((item, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleNavigation(item.uri)}
              sx={{
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'orange',
                },
              }}
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
        <Divider sx={{ borderBottomWidth: 4 }} />

  
        <Divider sx={{ borderBottomWidth: 4 }} />
        <MenuItem
          onClick={onLogout}
          sx={{
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: 'orange',
            },
          }}
        >
          Logout
        </MenuItem>
      </Drawer>
      )}
</>
    
  );
}

export default HeaderBar;